var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/zoom_in_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/zoom_in_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58083 8.80241H9.04167L11.9525 11.7191L11.0833 12.5882L8.16667 9.67741V9.21658L8.00917 9.05324C7.34417 9.62491 6.48083 9.96908 5.54167 9.96908C3.4475 9.96908 1.75 8.27158 1.75 6.17741C1.75 4.08324 3.4475 2.38574 5.54167 2.38574C7.63583 2.38574 9.33333 4.08324 9.33333 6.17741C9.33333 7.11658 8.98917 7.97991 8.4175 8.64491L8.58083 8.80241ZM2.91667 6.17741C2.91667 7.62991 4.08917 8.80241 5.54167 8.80241C6.99417 8.80241 8.16667 7.62991 8.16667 6.17741C8.16667 4.72491 6.99417 3.55241 5.54167 3.55241C4.08917 3.55241 2.91667 4.72491 2.91667 6.17741Z",
    fill: "#363E45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.d5a1a1d1837c8481a65e6d644ce7388a.svg";
export { ForwardRef as ReactComponent };